// extracted by mini-css-extract-plugin
export default {"shadowed":"About_shadowed__laI9z","pink":"About_pink__0olV+","green":"About_green__Njyxt","skills":"About_skills__HSntr"};